import Axios from "axios";

export function patch<T>(url: string, payload: any): Promise<T> {

    return Axios.patch<T>(url, payload)
        .then(res => {
            return res.data;
        }, res => {
            throw res;
        })
}
